import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    insertBulk(lista) {
        return this._http.post(`${this._env}/apiwebhookgatilho/insertbulk`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.post(`${this._env}/apiwebhookgatilho/delete`, id, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(id) {
        return this._http.post(`${this._env}/apiwebhookgatilho/updatesituacao`, id, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllGatilhos(idpartner, ...param) {
        return this._http.get(encodeURI(`${this._env}/apiwebhookgatilho/findallgatilhos.json?idpartner=${idpartner}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}